export default "__VITE_ASSET__BTdkR4aB__"